<template>
  <dd-number-input
      v-bind="$attrs"
      :title="title"
      :name="name"
      :rules="rules"
      :data-dusk="dataDusk"
      :parser="value => value.replace('%', '')"
      :formatter="value => `${value}%`"
      :min="min"
      :max="max"
      :value="value"
      @input="(value) => $emit('input', value)"
  />
</template>

<script>
export default {
  name: "PercentageInput.vue",
  emits: ['input'],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [Number, String],
      required: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
